// Default axios client (Clerk-token aware). Import as: `import api from './api'`.
import { apiClient } from './apiService';
export default apiClient;
